import React, { useEffect, useState } from "react";
import { Chart, registerables } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import {
  notification,
  Button,
  Row,
  Col,
  Card,
  Tag,
  Select,
  Spin,
  Table,
  Progress,
  DatePicker,
  Empty,
  Tooltip,
} from "antd";
import {
  ReloadOutlined,
  UserOutlined,
  ManOutlined,
  WomanOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
} from "@ant-design/icons";
import getVisitasTecnicas from "../../../services/visitas_tecnicas/visita_tecnica/getVisitasTecnicasService";
import ChartCard from "../../charts/ChartCard";
import { useSelector } from "react-redux";
import { getVisitasTecnicasSostenibilidad } from "../../../services/sostenibilidad/visitaTecnicaSostenibilidad/viistaTecnicaSostenibilidadService";
import ExportVisitasTecnicasSostenibilidad from "../VisitaTecnicaSostenibilidad/VisitasTecnicasSostenibilidadExcel";

const { RangePicker } = DatePicker;

Chart.register(...registerables, ChartDataLabels);
const { Option } = Select;

const cardStyle = {
  textAlign: "center",
  borderRadius: 20,
  backgroundColor: "#ffffff",
  boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
  padding: 20,
  height: "90%",
};

const iconContainerStyle = {
  width: 80,
  height: 80,
  borderRadius: "50%",
  backgroundColor: "#F44336",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  margin: "0 auto 10px",
};

const iconStyle = {
  fontSize: 40,
  color: "white",
};

const total = {
  fontSize: 30,
  color: "#333",
  margin: 0,
};

const InformeVisitasTecnicasSostenibilidad = () => {
  const [data, setData] = useState([]);
  const [dataOriginal, setDataOriginal] = useState([]);
  const [dataFilter, setDataFilter] = useState([]);
  const [loading, setLoading] = useState(true);

  const [departamentoSeleccionado, setDepartamentoSeleccionado] =
    useState(null);
  const [municipioSeleccionado, setMunicipioSeleccionado] = useState(null);
  const [sectorSeleccionado, setSectorSeleccionado] = useState(null);
  const [proyectoSeleccionado, setProyectoSeleccionado] = useState(null);

  const [modalidadVisitaSeleccionado, setModalidadVisitaSeleccionado] =
    useState(null);
  const [rangoFechas, setRangoFechas] = useState(null);

  const [modalidadSecion, setModalidadSecion] = useState(null);

  const [visitasPorDepartamento, setVisitasPorDepartamento] = useState({});
  const [visitasPorMunicipio, setVisitasPorMunicipio] = useState({});
  const [visitasPorSector, setVisitasPorSector] = useState({});
  const [visitasPorGenero, setVisitasPorGenero] = useState({});
  const [visitasPorFecha, setVisitasPorFecha] = useState(null);
  const [visitasPorProyecto, setVisitasPorProyecto] = useState(null);
  const [visitasPorTipoActividad, setVisitasPorTipoActividad] = useState(null);
  const [visitasPorQuienResiveVisita, setVisitasPorQuienResiveVisita] =
    useState(null);
  const [visitasPorTipoAnexo, setVisitasPorTipoAnexo] = useState(null);
  const [
    visitasPornumeroPersonasParticipan,
    setVisitasPornumeroPersonasParticipan,
  ] = useState(null);
  const [visitasPornumeroHombreMujer, setVisitasPornumeroHombreMujer] =
    useState(null);
  const [visitasPorFormaAsociativa, setVisitasPorFormaAsociativa] =
    useState(null);

  const [listDepartamento, setListDepartamento] = useState([]);
  const [listMunicipio, setListMunicipio] = useState([]);
  const [listSector, setListSector] = useState([]);
  const [listProyectos, setListProyectos] = useState([]);

  const [listMunicipiosPorDepartamento, setListMunicipiosPorDepartamento] =
    useState([]);
  const [listModalidadVisita, setlisModalidadVisita] = useState([]);

  const sectores = ["Pecuaria", "Agrícola", "Servicios"];

  const [indicadores, setIndicadores] = useState({
    totalVisitas: 0,
    totalProyectosVisitados: 0,
    duracionPromedioVisitas: 0,
  });

  const usernameFromState = useSelector((state) => state.auth.user);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const fetchData = async () => {
    try {
      const response = await getVisitasTecnicasSostenibilidad(
        usernameFromState.email
      );
      const { status, data } = response;

      if (status) {
        setData(data);
        setDataOriginal(data); // Guarda la data original
        setDataFilter(data);
        const departamentos = [...new Set(data.map((p) => p.departamento))];
        setListDepartamento(departamentos);
        // Agrupar municipios por departamento
        const municipiosPorDepartamento = data.reduce((acc, p) => {
          if (!acc[p.departamento]) {
            acc[p.departamento] = new Set();
          }
          acc[p.departamento].add(p.municipio);
          return acc;
        }, {});
        //Almacenamos la lista de municipios por departamento
        setListMunicipiosPorDepartamento(municipiosPorDepartamento);
        setListSector(sectores);

        //Almacenar la lista de proyectos
        const proyectos = [
          ...new Set(data.map((p) => p.nombreFormaAsociativa)),
        ];
        setListProyectos(proyectos);

        const modalidad_visitas = [
          ...new Set(data.map((p) => p.modalidad_sesion_capacitacion)),
        ];
        setlisModalidadVisita(modalidad_visitas);

        calcularIndicadores(data);
        setLoading(false);
      } else {
        setData([]);
        setDataOriginal([]);
        setDataFilter([]);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      setData([]);
      setDataOriginal([]);
      setDataFilter([]);
    }
  };

  useEffect(() => {
    if (!data) return;

    let visitasFiltradas = [...data];

    if (departamentoSeleccionado) {
      visitasFiltradas = visitasFiltradas.filter(
        (p) => p.departamento === departamentoSeleccionado
      );

      // Lista de municipios filtrados por el departamento seleccionado
      const municipios = departamentoSeleccionado
        ? [...listMunicipiosPorDepartamento[departamentoSeleccionado]]
        : [];
      setListMunicipio(municipios);
    }

    if (municipioSeleccionado) {
      visitasFiltradas = visitasFiltradas.filter(
        (p) => p.municipio === municipioSeleccionado
      );
    }

    if (sectorSeleccionado) {
      visitasFiltradas = visitasFiltradas.filter(
        (p) => p.linea_productiva === sectorSeleccionado
      );
    }
    if (proyectoSeleccionado) {
      visitasFiltradas = visitasFiltradas.filter(
        (p) => p.nombreFormaAsociativa === proyectoSeleccionado
      );
    }
    if (modalidadVisitaSeleccionado) {
      visitasFiltradas = visitasFiltradas.filter(
        (p) => p.modalidad_sesion_capacitacion === modalidadVisitaSeleccionado
      );
    }
    if (rangoFechas) {
      const [inicio, fin] = rangoFechas;
      visitasFiltradas = visitasFiltradas.filter((visita) => {
        const fechaVisita = new Date(visita.fecha_registro);
        return fechaVisita >= new Date(inicio) && fechaVisita <= new Date(fin);
      });
    }
    calcularIndicadores(visitasFiltradas);
  }, [
    departamentoSeleccionado,
    municipioSeleccionado,
    sectorSeleccionado,
    modalidadVisitaSeleccionado,
    rangoFechas,
    proyectoSeleccionado,
    data,
  ]);

  useEffect(() => {
    fetchData();
  }, []);

  const calcularIndicadores = (datos) => {
    //Total de visitas
    const totalVisitas = datos.length;
    // Total de participantes unicos visitados
    const totalProyectosVisitados = new Set(
      datos.map((item) => item.nombreFormaAsociativa)
    ).size;

    //Promedio de duración por visita
    const duracionPromedioVisitas = calcularPromedioDuracion(datos);
    setIndicadores({
      totalVisitas,
      totalProyectosVisitados,
      duracionPromedioVisitas,
    });

    //Visitas por departamento
    const departamentosTemp = {};
    datos.forEach((p) => {
      departamentosTemp[p.departamento] =
        (departamentosTemp[p.departamento] || 0) + 1;
    });
    setVisitasPorDepartamento(departamentosTemp);

    //Visitas por municipio
    const municipiosTemp = {};
    datos.forEach((p) => {
      municipiosTemp[p.municipio] = (municipiosTemp[p.municipio] || 0) + 1;
    });
    setVisitasPorMunicipio(municipiosTemp);

    //Visitas por sector
    const sectorTemp = {};
    datos.forEach((p) => {
      sectorTemp[p.linea_productiva] =
        (sectorTemp[p.linea_productiva] || 0) + 1;
    });
    setVisitasPorSector(sectorTemp);

    //visitas por modalidad de secion
    const modalidadSecionTemp = {};
    datos.forEach((p) => {
      modalidadSecionTemp[p.modalidad_sesion_capacitacion] =
        (modalidadSecionTemp[p.modalidad_sesion_capacitacion] || 0) + 1;
    });
    setModalidadSecion(modalidadSecionTemp);

    //Visitas por genero
    const resultGeneroTemp = obtenerDatosNumeroVisitaPorSexo(datos);
    setVisitasPorGenero(resultGeneroTemp);

    const visitasPorMesMap = datos.reduce((acc, visita) => {
      const fechaStr = visita.fecha_registro;
      if (!fechaStr) return acc;

      const fecha = new Date(fechaStr);
      const year = fecha.getFullYear();
      const month = fecha.getMonth(); // 0 = enero

      const key = `${year}-${month}`; // Clave ordenable, ej: "2025-3"
      acc[key] = (acc[key] || 0) + 1;

      return acc;
    }, {});

    // Ordenar las claves cronológicamente
    const visitasPorMesOrdenadas = Object.entries(visitasPorMesMap)
      .sort(([a], [b]) => {
        const [aYear, aMonth] = a.split("-").map(Number);
        const [bYear, bMonth] = b.split("-").map(Number);
        return aYear !== bYear ? aYear - bYear : aMonth - bMonth;
      })
      .reduce((acc, [key, count]) => {
        const [year, month] = key.split("-").map(Number);

        // Crear objeto Date con mes+1 (porque getMonth() es 0-indexed)
        const fecha = new Date(year, month);
        const mesLegible = fecha.toLocaleDateString("es-ES", {
          month: "long",
          year: "numeric",
        });
        const mesCapitalizado =
          mesLegible.charAt(0).toUpperCase() + mesLegible.slice(1);

        acc[mesCapitalizado] = count;
        return acc;
      }, {});

    setVisitasPorFecha(visitasPorMesOrdenadas);

    let proyectosConVisitas = {};

    //Total de Visitas por participante
    // Agrupar información y contar visitas

    datos.forEach((item) => {
      const { codigo_interno, modalidad_sesion_capacitacion } = item;

      if (!proyectosConVisitas[codigo_interno]) {
        proyectosConVisitas[codigo_interno] = {
          codigo_interno: item.codigo_interno,
          departamento: item.departamento,
          municipio: item.municipio,
          grupoTerritorial: item.grupoTerritorial,
          nombreFormaAsociativa: item.nombreFormaAsociativa,
          nombreProyecto: item.nombreProyecto,
          linea_productiva: item.linea_productiva,
          total_visitas: 0,
        };
      }

      // Incrementar visitas totales
      proyectosConVisitas[codigo_interno].total_visitas++;

      // 🔹 Contar visitas por modalidad
      const modalidad = modalidad_sesion_capacitacion || "SIN_MODALIDAD";
      if (!proyectosConVisitas[codigo_interno][modalidad]) {
        proyectosConVisitas[codigo_interno][modalidad] = 0;
      }
      proyectosConVisitas[codigo_interno][modalidad]++;
    });

    // Convertir a array
    const proyectosArray = Object.entries(proyectosConVisitas).map(
      ([id, data]) => ({
        codigo_interno: id,
        ...data,
      })
    );

    setVisitasPorProyecto(proyectosArray);

    //Visitas por modalidad
    const tipoActividadTemp = {};
    datos.forEach((p) => {
      tipoActividadTemp[p.tipoActividad] =
        (tipoActividadTemp[p.tipoActividad] || 0) + 1;
    });
    setVisitasPorTipoActividad(tipoActividadTemp);

    //Visitas por quien recibe la visita
    const quienRecibeVisitaTemp = {};
    datos.forEach((p) => {
      quienRecibeVisitaTemp[p.quienRecibeVisita] =
        (quienRecibeVisitaTemp[p.quienRecibeVisita] || 0) + 1;
    });
    setVisitasPorQuienResiveVisita(quienRecibeVisitaTemp);

    if (!Array.isArray(datos)) return;

    const contarFirmas = datos.reduce(
      (acc, visita) => {
        const modo = visita.modoFirma ?? null;

        if (modo === "anexo_firma_participantes") {
          acc["Lista de asistencia"] = (acc["Lista de asistencia"] || 0) + 1;
        } else {
          acc["Firma digital"] = (acc["Firma digital"] || 0) + 1;
        }

        return acc;
      },
      {
        "Lista de asistencia": 0,
        "Firma digital": 0,
      }
    );

    setVisitasPorTipoAnexo(contarFirmas);

    //Visitas por Numero de personas que participan en la visita
    const numeroPersonasParticipanTemp = {};
    datos.forEach((p) => {
      numeroPersonasParticipanTemp[p.numeroPersonasParticipan] =
        (numeroPersonasParticipanTemp[p.numeroPersonasParticipan] || 0) + 1;
    });
    setVisitasPornumeroPersonasParticipan(numeroPersonasParticipanTemp);

    //Visitas por Numero de Hombres y mujeres que participan en la visita
    // 📌 Reducir el array para sumar los valores
    const numeroHombresMujeresnTemp = datos.reduce(
      (acc, visita) => {
        acc.numeroHombres += Number(visita.numeroHombres) || 0;
        acc.numeroMujeres += Number(visita.numeroMujeres) || 0;
        return acc;
      },
      { numeroHombres: 0, numeroMujeres: 0 } // Estado inicial
    );

    setVisitasPornumeroHombreMujer(numeroHombresMujeresnTemp);

    //Visitas por forma asociativa
    const formaAsociativaTemp = {};
    datos.forEach((p) => {
      formaAsociativaTemp[p.nombreFormaAsociativa] =
        (formaAsociativaTemp[p.nombreFormaAsociativa] || 0) + 1;
    });

    setVisitasPorFormaAsociativa(formaAsociativaTemp);
    setVisitasPorFormaAsociativa(formaAsociativaTemp);

    //Visitas por tema de capacitación
    setDataFilter(datos);
  };

  const obtenerDatosNumeroVisitaPorSexo = (datos) => {
    return datos.reduce((acc, visita) => {
      const numVisita = visita.numero_visita;
      const sexo = visita.sexo_sir || "No especificado"; // Si no tiene sexo, lo agrupa en "No especificado"

      if (!acc[numVisita]) {
        acc[numVisita] = {};
      }

      if (!acc[numVisita][sexo]) {
        acc[numVisita][sexo] = 0;
      }

      acc[numVisita][sexo] += 1; // Contar cuántas personas hay por género en cada visita

      return acc;
    }, {});
  };

  const calcularPromedioDuracion = (visitas) => {
    if (!Array.isArray(visitas) || visitas.length === 0) {
      return "0h 0min"; // Evita errores si el array está vacío
    }

    const convertirAMinutos = (hora) => {
      if (!hora) return 0; // Manejo de valores undefined/null

      const [time, meridian] = hora.split(" ");
      if (!time || !meridian) return 0; // Evita errores si el formato es incorrecto

      const [horas, minutos] = time.split(":").map(Number);
      let totalMinutos = horas * 60 + minutos;

      // Convertir a formato 24 horas
      if (meridian.toLowerCase() === "pm" && horas !== 12)
        totalMinutos += 12 * 60;
      if (meridian.toLowerCase() === "am" && horas === 12)
        totalMinutos -= 12 * 60;

      return totalMinutos;
    };

    // Calcular la duración total
    let totalMinutos = 0;
    let visitasValidas = 0;

    visitas.forEach((visita) => {
      if (visita.horaInicio && visita.horaFin) {
        const inicioMinutos = convertirAMinutos(visita.horaInicio);
        const finMinutos = convertirAMinutos(visita.horaFin);

        if (finMinutos > inicioMinutos) {
          // Asegura que la hora de fin sea mayor
          totalMinutos += finMinutos - inicioMinutos;
          visitasValidas++;
        }
      }
    });

    // Evita división por cero
    if (visitasValidas === 0) return "0h 0min";

    // Calcular el promedio en minutos
    const promedioMinutos = totalMinutos / visitasValidas;

    // Convertir minutos a horas y minutos
    const horas = Math.floor(promedioMinutos / 60);
    const minutos = Math.round(promedioMinutos % 60);

    return `${horas}h ${minutos}min`;
  };

  // 1. Identificar todas las modalidades distintas
  const modalidades = [
    ...new Set(dataFilter.map((item) => item.modalidad_sesion_capacitacion)),
  ];

  // 2. Columnas base (fijas)
  const baseColumns = [
    {
      title: "Código interno",
      dataIndex: "codigo_interno",
      key: "codigo_interno",
      width: 150,
    },
    {
      title: "Departamento",
      dataIndex: "departamento",
      key: "departamento",
      width: 150,
    },
    {
      title: "Municipio",
      dataIndex: "municipio",
      key: "municipio",
      width: 150,
    },
    {
      title: "Grupo territorial",
      dataIndex: "grupoTerritorial",
      key: "grupoTerritorial",
      width: 150,
    },
    {
      title: "Forma asociativa",
      dataIndex: "nombreFormaAsociativa",
      key: "nombreFormaAsociativa",
      width: 150,
    },
    {
      title: "Línea productiva",
      dataIndex: "linea_productiva",
      key: "linea_productiva",
      width: 150,
    },
    {
      title: "Nombre del proyecto",
      dataIndex: "nombreProyecto",
      key: "nombreProyecto",
      width: 150,
      render: (text) => {
        const maxLength = 50;
        const displayText =
          text && text.length > maxLength
            ? text.substring(0, maxLength) + "..."
            : text;

        return (
          <Tooltip title={text}>
            <span>{displayText}</span>
          </Tooltip>
        );
      },
    },
  ];

  // 3. Columnas dinámicas agrupadas bajo "Modalidad de visita"
  const modalidadColumnsGroup = {
    title: "Modalidad de visita",
    children: modalidades.map((modalidad) => ({
      title: modalidad,
      dataIndex: modalidad, // este campo debe estar en cada proyecto
      key: modalidad,
      align: "center",
      width: 150,
    })),
  };

  // 4. Columna final de totales
  const totalColumn = {
    title: "Total de Visitas",
    dataIndex: "total_visitas",
    key: "total_visitas",
    align: "center",
    width: 150,
  };

  // 5. Combinar todo
  const columns = [...baseColumns, modalidadColumnsGroup, totalColumn];

  return (
    <>
      {loading ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "80vh",
            background: "#F6FAFF",
          }}
        >
          <Spin size="large" />
          <p style={{ marginTop: 16, fontSize: 16, color: "#888" }}>
            Cargando datos...
          </p>
        </div>
      ) : Array.isArray(dataOriginal) && dataOriginal.length === 0 ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "70vh",
            background: "#F6FAFF",
            borderRadius: 16,
            boxShadow: "0 2px 8px rgba(20,91,173,0.08)",
          }}
        >
          <Empty
            description={
              <span
                style={{
                  fontSize: 20,
                  color: "#145BAD",
                  fontWeight: "bold",
                }}
              >
                No hay Visitas disponibles
              </span>
            }
            image={Empty.PRESENTED_IMAGE_SIMPLE}
          />
          <p style={{ color: "#888", marginTop: 8, fontSize: 15 }}>
            No se encontraron registros de visitas técnicas de sostenibilidad
          </p>
          <Button
            type="primary"
            icon={<ReloadOutlined />}
            style={{ marginTop: 24 }}
            onClick={() => window.location.reload()}
          >
            Volver a intentar
          </Button>
        </div>
      ) : (
        <Card style={{ padding: 20 }}>
          <Tag
            color="#D0E0F2"
            style={{
              color: "#145BAD",
              fontSize: "25px",
              fontWeight: "bold",
              padding: "8px 15px",
              borderRadius: "8px",
              textAlign: "center",
              display: "block",
              marginBottom: "15px",
            }}
          >
            INFORME VISITAS TÉCNICAS - SOSTENIBILIDAD
          </Tag>
          {/* 🔹 Encabezado de Filtros */}
          {/* Encabezado de Filtros */}
          <Row gutter={[16, 16]} style={{ marginBottom: 10 }}>
            {/* Filtros */}
            <Col xs={24} sm={12} md={4}>
              <Select
                placeholder="Departamento"
                style={{ width: "100%" }}
                value={departamentoSeleccionado}
                onChange={(value) => {
                  setDepartamentoSeleccionado(value);
                  setMunicipioSeleccionado(null);
                }}
                disabled={!listDepartamento?.length}
                allowClear
                showSearch
                optionFilterProp="children" // busca dentro del texto de las opciones
              >
                {listDepartamento.map((dep) => (
                  <Option key={dep} value={dep}>
                    {dep}
                  </Option>
                ))}
              </Select>
            </Col>

            <Col xs={24} sm={12} md={4}>
              <Select
                placeholder="Municipio"
                style={{ width: "100%" }}
                value={municipioSeleccionado || undefined}
                onChange={(value) => setMunicipioSeleccionado(value)}
                disabled={!listMunicipio?.length}
                allowClear
                showSearch
                optionFilterProp="children" // busca dentro del texto de las opciones
              >
                {listMunicipio?.map((mun) => (
                  <Option key={mun} value={mun}>
                    {mun}
                  </Option>
                ))}
              </Select>
            </Col>

            <Col xs={24} sm={12} md={4}>
              <Select
                placeholder="Proyecto"
                style={{ width: "100%" }}
                value={proyectoSeleccionado || undefined}
                onChange={(value) => setProyectoSeleccionado(value)}
                disabled={!listProyectos?.length}
                allowClear
                showSearch
                optionFilterProp="children" // busca dentro del texto de las opciones
              >
                {listProyectos?.map((p) => (
                  <Option key={p} value={p}>
                    {p}
                  </Option>
                ))}
              </Select>
            </Col>

            <Col xs={24} sm={12} md={4}>
              <Select
                placeholder="Sector"
                style={{ width: "100%" }}
                value={sectorSeleccionado}
                onChange={setSectorSeleccionado}
                disabled={!listSector?.length}
                allowClear
                showSearch
                optionFilterProp="children" // busca dentro del texto de las opciones
              >
                {listSector.map((sec) => (
                  <Option key={sec} value={sec}>
                    {sec}
                  </Option>
                ))}
              </Select>
            </Col>

            <Col xs={24} sm={12} md={4}>
              <Select
                placeholder="Modalidad de visita"
                style={{ width: "100%" }}
                value={modalidadVisitaSeleccionado}
                onChange={setModalidadVisitaSeleccionado}
                disabled={!listModalidadVisita?.length}
                allowClear
                showSearch
                optionFilterProp="children" // busca dentro del texto de las opciones
              >
                {listModalidadVisita.map((mod) => (
                  <Option key={mod} value={mod}>
                    {mod}
                  </Option>
                ))}
              </Select>
            </Col>

            <Col xs={24} sm={12} md={4}>
              <RangePicker
                style={{ width: "100%" }}
                value={rangoFechas}
                onChange={setRangoFechas}
              />
            </Col>
          </Row>

          {/* Acciones */}
          <Row justify="end" gutter={[8, 8]} style={{ marginBottom: 20 }}>
            <Col>
              <Button
                icon={<ReloadOutlined />}
                onClick={() => {
                  setDepartamentoSeleccionado(null);
                  setMunicipioSeleccionado(null);
                  setProyectoSeleccionado(null);
                  setSectorSeleccionado(null);
                  setModalidadVisitaSeleccionado(null);
                  setRangoFechas(null);
                }}
              >
                Restablecer
              </Button>
            </Col>
            <Col>
              <ExportVisitasTecnicasSostenibilidad dataCompleta={dataFilter} />
            </Col>
          </Row>

          {/*TOTALIZADORES EN CARDS */}
          <Row gutter={[24, 24]} style={{ margin: "20px 40px" }}>
            <Col xs={24} sm={12} md={8}>
              <Card bordered={false} style={cardStyle}>
                <div
                  style={{ ...iconContainerStyle, backgroundColor: "#468CDE" }}
                >
                  <ManOutlined style={iconStyle} />
                </div>
                <h3
                  style={{
                    fontSize: 15,
                    fontWeight: "bold",
                    color: "#468CDE",
                    marginBottom: 5,
                  }}
                >
                  Total visitas
                </h3>
                <h2 style={total}>{indicadores.totalVisitas}</h2>
              </Card>
            </Col>

            <Col xs={24} sm={12} md={8}>
              <Card bordered={false} style={cardStyle}>
                <div
                  style={{ ...iconContainerStyle, backgroundColor: "#0051AE" }}
                >
                  <WomanOutlined style={iconStyle} />
                </div>
                <h3
                  style={{
                    fontSize: 15,
                    fontWeight: "bold",
                    color: "#0051AE",
                    marginBottom: 5,
                  }}
                >
                  Total proyectos visitados
                </h3>
                <h2 style={total}>{indicadores.totalProyectosVisitados}</h2>
              </Card>
            </Col>

            <Col xs={24} sm={12} md={8}>
              <Card bordered={false} style={cardStyle}>
                <div
                  style={{ ...iconContainerStyle, backgroundColor: "#C2BCBC" }}
                >
                  <ClockCircleOutlined style={iconStyle} />
                </div>
                <h3
                  style={{
                    fontSize: 15,
                    fontWeight: "bold",
                    color: "#C2BCBC",
                    marginBottom: 5,
                  }}
                >
                  Promedio de tiempo por visita
                </h3>
                <h2 style={total}>{indicadores.duracionPromedioVisitas}</h2>
              </Card>
            </Col>
          </Row>

          <Card style={{ padding: 20 }}>
            <Tag
              color="#D0E0F2"
              style={{
                color: "#145BAD",
                fontSize: "20px",
                fontWeight: "bold",
                padding: "8px 15px",
                borderRadius: "8px",
                textAlign: "left",
                display: "block",
                marginBottom: "15px",
              }}
            >
              INFORMACIÓN GENERAL
            </Tag>

            <Row gutter={[16]} style={{ marginTop: 20 }}>
              {/* Gráfico 1: Visitas por Departamento o Municipio */}
              <Col xs={24} sm={24} md={12} lg={12}>
                <ChartCard
                  title={
                    departamentoSeleccionado
                      ? `Número de visitas por municipio en ${departamentoSeleccionado}`
                      : "Número de visitas por departamento"
                  }
                  data={{
                    labels: departamentoSeleccionado
                      ? Object.keys(visitasPorMunicipio)
                      : Object.keys(visitasPorDepartamento),
                    datasets: [
                      {
                        label: municipioSeleccionado
                          ? "Municipio"
                          : departamentoSeleccionado
                          ? "Departamento"
                          : "Departamento",
                        data: departamentoSeleccionado
                          ? Object.values(visitasPorMunicipio)
                          : Object.values(visitasPorDepartamento),
                        backgroundColor: "#145BAD",
                        borderRadius: 5,
                        barThickness: 40,
                      },
                    ],
                  }}
                  backgroundColor="#145BAD"
                />
              </Col>

              {/*Gráfico 3 - Número de visitas por fecha*/}
              <Col xs={24} sm={24} md={12} lg={12}>
                <ChartCard
                  title="Número de visitas  por fecha"
                  data={{
                    labels: Object.keys(visitasPorFecha),
                    datasets: [
                      {
                        label: "Fecha",
                        data: Object.values(visitasPorFecha),
                        backgroundColor: "#5B93D3",
                        borderRadius: 5,
                        barThickness: 40,
                      },
                    ],
                  }}
                  backgroundColor="#5B93D3"
                />
              </Col>
              {/* Gráfico 2: Visitas por Sector */}
              <Col xs={24} sm={24} md={12} lg={12}>
                <ChartCard
                  title="Número de visitas  por sector"
                  data={{
                    labels: Object.keys(visitasPorSector),
                    datasets: [
                      {
                        label: "Sector",
                        data: Object.values(visitasPorSector),
                        backgroundColor: "#5B93D3",
                        borderRadius: 5,
                        barThickness: 40,
                      },
                    ],
                  }}
                  backgroundColor="#5B93D3"
                />
              </Col>

              {/* Gráfico 2: Visitas por orma asociativa */}
              <Col xs={24} sm={24} md={12} lg={12}>
                <ChartCard
                  title="Número de visitas por forma asociativa"
                  data={{
                    labels: Object.keys(visitasPorFormaAsociativa),
                    datasets: [
                      {
                        label: "Entidad",
                        data: Object.values(visitasPorFormaAsociativa),
                        backgroundColor: "#5B93D3",
                        borderRadius: 5,
                        barThickness: 40,
                      },
                    ],
                  }}
                  backgroundColor="#5B93D3"
                />
              </Col>

              {/*Tabla de resumen datos generales */}
              <Col xs={24} sm={24} md={24} lg={24}>
                <div style={{ overflowX: "auto", marginTop: 30 }}>
                  <Table
                    dataSource={visitasPorProyecto}
                    columns={columns}
                    rowKey="codigo_interno"
                    scroll={{ y: 500, x: "max-content" }}
                    pagination={{
                      current: currentPage, // página actual
                      pageSize: pageSize, // filas por página
                      total: visitasPorProyecto.length, // total de registros
                      showSizeChanger: true,
                      pageSizeOptions: ["10", "20", "50", "100"],
                      showTotal: (total, range) =>
                        `${range[0]}-${range[1]} de ${total} registros`,
                      onChange: (page, size) => {
                        setCurrentPage(page);
                        setPageSize(size);
                      },
                    }}
                    bordered
                  />
                </div>
              </Col>
            </Row>
          </Card>
          <Card style={{ padding: 20 }}>
            <Tag
              color="#D0E0F2"
              style={{
                color: "#145BAD",
                fontSize: "20px",
                fontWeight: "bold",
                padding: "8px 15px",
                borderRadius: "8px",
                textAlign: "left",
                display: "block",
                marginBottom: "15px",
              }}
            >
              INFORMACIÓN INTERNA
            </Tag>

            <Row gutter={[16]} style={{ marginTop: 20 }}>
              {/*Gráfico 6 -  Visitas por tipo de actividad*/}
              <Col xs={24} sm={24} md={12} lg={12}>
                <ChartCard
                  title="% de visitas por tipo de actividad"
                  chartType="pie"
                  showAsPercentage={true}
                  data={{
                    labels: Object.keys(visitasPorTipoActividad),
                    datasets: [
                      {
                        label: "Tipo actividad",
                        data: Object.values(visitasPorTipoActividad),
                        backgroundColor: [
                          "#145BAD",
                          "rgba(54, 162, 235, 0.6)",
                          "rgba(75, 192, 192, 0.6)",
                          "#D4D2D2",
                          "rgba(255, 99, 132, 0.6)",
                          "rgba(255, 159, 64, 0.6)",
                        ],
                        borderRadius: 5, // Bordes redondeados en las barras
                        barThickness: 40, // Define el grosor de las barras
                      },
                    ],
                  }}
                />
              </Col>

              {/*Gráfico 5 - Visitas Técnicas por Modalidad de sesión*/}

              <Col xs={24} sm={24} md={12} lg={12}>
                <ChartCard
                  title="% de visitas por modalidad de capacitación"
                  chartType="pie"
                  showAsPercentage={true}
                  data={{
                    labels: Object.keys(modalidadSecion),
                    datasets: [
                      {
                        label: "Tipo Modalidad",
                        data: Object.values(modalidadSecion),
                        backgroundColor: [
                          "#145BAD",
                          "rgba(54, 162, 235, 0.6)",
                          "rgba(75, 192, 192, 0.6)",
                          "#D4D2D2",
                          "rgba(255, 99, 132, 0.6)",
                          "rgba(255, 159, 64, 0.6)",
                        ],
                        borderRadius: 5, // Bordes redondeados en las barras
                        barThickness: 40, // Define el grosor de las barras
                      },
                    ],
                  }}
                />
              </Col>

              {/*Gráfico 8 - */}
              <Col xs={24} sm={24} md={12} lg={12}>
                <ChartCard
                  title="Número de visitas por tipo de anexo"
                  chartType="bar"
                  data={{
                    labels: Object.keys(visitasPorTipoAnexo),
                    datasets: [
                      {
                        label: "Tipo anexo",
                        data: Object.values(visitasPorTipoAnexo),
                        backgroundColor: "#5B93D3",
                        borderRadius: 5, // Bordes redondeados en las barras
                        barThickness: 40, // Define el grosor de las barras
                      },
                    ],
                  }}
                />
              </Col>

              {/*Gráfico 10 - */}
              <Col xs={24} sm={24} md={12} lg={12}>
                <ChartCard
                  title="Personas que participan en la visita por género"
                  chartType="bar"
                  data={{
                    labels: ["Hombres", "Mujeres"],
                    datasets: [
                      {
                        label: "Número de personas",
                        data: [
                          visitasPornumeroHombreMujer.numeroHombres,
                          visitasPornumeroHombreMujer.numeroMujeres,
                        ],
                        backgroundColor: [
                          "#145BAD",
                          "rgba(54, 162, 235, 0.6)",
                          "rgba(75, 192, 192, 0.6)",
                          "#D4D2D2",
                          "rgba(255, 99, 132, 0.6)",
                          "rgba(255, 159, 64, 0.6)",
                        ],
                        borderRadius: 5, // Bordes redondeados en las barras
                        barThickness: 40, // Define el grosor de las barras
                      },
                    ],
                  }}
                />
              </Col>
            </Row>
          </Card>
        </Card>
      )}
    </>
  );
};

export default InformeVisitasTecnicasSostenibilidad;
